import * as TYPES from './actionTypes';
import axios from 'axios';
import * as serviceEndPoint from '../../../../../SharedModules/services/service';

export const setErrorMessages = (payload) => {
  return {
    type: TYPES.SET_ERROR_MESSAGES_PRT,
    payload,
  };
};

export const setSuccessMessages = (payload) => {
  return {
    type: TYPES.SET_SUCCESS_MESSAGES,
    payload,
  };
};

export const setPlanType = (payload) => {
  return {
    type: TYPES.SET_PLAN_TYPE,
    payload,
  };
};
//action set Network error
export const setNetworkError = (data) => ({
  type: TYPES.SET_NEWORK_ERROR,
  payload: data,
});

export const setSelectType = (payload) => {
  return {
    type: TYPES.SET_SELECT_TYPE,
    payload,
  };
};

export const setRebateProgram = (payload) => {
  return {
    type: TYPES.SET_REBATE_PROGRAM,
    payload,
  };
};

export const setStartDate = (payload) => {
  return {
    type: TYPES.SET_START_DATE,
    payload,
  };
};

export const setEndDate = (payload) => {
  return {
    type: TYPES.SET_END_DATE,
    payload,
  };
};

export const setErrors = (payload) => {
  return {
    type: TYPES.SET_ERRORS,
    payload,
  };
};

export const resetPeriodicReportStore = () => {
  return {
    type: TYPES.RESET_PERIODIC_REPORT_STORE,
  };
};
export const getRebateProgramCodePRT = (values) => async (dispatch) => {
  if (values) {
    try {
      const response = await axios.post(
        `${serviceEndPoint.GET_ALL_REBATE_PROGRAMS}`,
        { planType: values }
      );
      if (
        response.data &&
        response.data.data &&
        response.data.data.length > 0
      ) {
        let newData = [];
        response.data.data.forEach((item) => {
          newData.push({
            label: `${item.rebateProgramCd} | ${item.shortDescr}`,
            value: item.rebateProgramCd,
            ...item,
          });
        });
        dispatch({ type: TYPES.SET_REBATE_LIST, payload: newData });
      } else {
        dispatch({ type: TYPES.SET_REBATE_LIST, payload: [] });
      }
    } catch (e) {
      dispatch({ type: TYPES.SET_REBATE_LIST, payload: [] });
    }
  }
};
